import { __assign, __spreadArrays } from "tslib";
var GuestDetailsBuilder = /** @class */ (function () {
    function GuestDetailsBuilder() {
        this.guestDetails = {
            guestAssigned: true,
            firstName: 'first',
            lastName: 'first',
            email: 'arnoldass@wix.com',
            form: {
                inputValues: [
                    {
                        inputName: 'firstName',
                        value: 'first',
                        values: [],
                        number: 0,
                    },
                    { inputName: 'lastName', value: 'first', values: [], number: 0 },
                    {
                        inputName: 'email',
                        value: 'arnoldass@wix.com',
                        values: [],
                        number: 0,
                    },
                ],
            },
            contactId: 'd95bcf72-0062-4c72-abe9-5a7449d05b0f',
        };
    }
    GuestDetailsBuilder.prototype.withCheckboxAnswer = function (inputName, values) {
        this.guestDetails.form.inputValues = __spreadArrays(this.guestDetails.form.inputValues, [
            {
                inputName: inputName,
                number: 0,
                value: '',
                values: values,
            },
        ]);
        return this;
    };
    GuestDetailsBuilder.prototype.build = function () {
        return __assign({}, this.guestDetails);
    };
    return GuestDetailsBuilder;
}());
export { GuestDetailsBuilder };
//# sourceMappingURL=guest-details.builder.js.map